import * as React from "react";
import HeadersWithContent from "./TwoHeadersWithContext";
import CryptoFunctionsList from "./CryptoFunctionsList";
import { PrimaryBigButton } from "../Buttons/PrimaryBigButton";
import { PrimaryButtonRoute } from "../Buttons/PrimaryRoute";

const titleObj = {
    h1: "Your Keys, ",
    h2: "Your Crypto!",
    h3: "Changex offers all the benefits of CEX in a 100% non-custodial, multi-chain wallet, where you get to own the keys of your crypto!",
    h2_1: "The Exchange"
}

const list = [
    {
        url: '/assets/images/common/elipse_blue.svg',
        text: 'Buy Crypto'
    },
    {
        url: '/assets/images/common/elipse_green.svg',
        text: 'Sell Crypto'
    },
    {
        url: '/assets/images/common/elipse_blue.svg',
        text: 'Swap Crypto'
    },
    {
        url: '/assets/images/common/elipse_green.svg',
        text: 'Send Crypto'
    },
    {
        url: '/assets/images/common/elipse_blue.svg',
        text: 'Receive Crypto'
    },
    {
        url: '/assets/images/common/elipse_green.svg',
        text: 'Store Crypto'
    },

]
export default function SectionTheExchangeHome() {
    return (
        <>
            <section className="margin-top-small">

                <div data-aos='fade-up'
                    data-aos-duration='1000'
                    className="padding-global" >
                    <div className="container-large">
                        <div className="image-with-text-exchange padding-medium">
                            <div className="">
                                <HeadersWithContent obj={titleObj} />
                                <CryptoFunctionsList items={list} />
                                <div className="padding-top-small">
                                    <PrimaryButtonRoute text={'Download Now'} url={'https://urlgeni.us/changexapp'} alt={'Download'} />
                                </div>
                            </div>
                            <div className="padding-medium">
                                <img width="auto"
                                    height="auto"
                                    src={'/assets/images/wallet/wallet_home.webp'}
                                    alt='Test'
                                    loading="lazy" />
                            </div>
                        </div>

                        <div className="image-with-text-exchange-small padding-medium">
                            <div className="">
                                <HeadersWithContent obj={titleObj} />
                                <CryptoFunctionsList items={list} />
                            </div>
                            <div className="padding-medium">
                                <img width="auto"
                                    height="auto"
                                    src={'/assets/images/wallet/wallet_home.webp'}
                                    alt='Test'
                                    loading="lazy" />
                            </div>
                            <PrimaryBigButton text={'Download Now'} url={'https://urlgeni.us/changexapp'} alt={'Download'} />

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}